import React, { useRef, useState, useEffect } from "react";
import ExpandableTextMobile from "../components/ExpandableText";
import { Modal } from "react-bootstrap";
import { BASE_MOBILE_API_URL, BASIC_AUTH, formatMonthDate } from "../constants";
import { notifySuccess } from "../components/notify";
import axios from "axios";
import ButtonSpinner from "../components/Spinner/ButtonSpinner";

const OrderList = ({
  ordersData,
  loading,
  setSelectedOrder,
  setShowModal,
  notifyError,
  setCreateOrderModal,
  refreshOrders,
}) => {

  const customerStr = localStorage.getItem("customerInfo");
  const customer = customerStr ? JSON.parse(customerStr) : null;

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showAddPaymentModal, setShowAddPaymentModal] = useState(false);
  const [selectedPaymentOrder, setSelectedPaymentOrder] = useState(null);
  const [selectedOrderAssign, setSelectedOrderAssign] = useState(null);
  const [showdeliveryModal, setShowdeliveryModal] = useState(false);
  const [sendQRModal, setSendQRModal] = useState(false);
  const [mobile, setMobile] = useState("");
  const [mobileError, setMobileError] = useState("");

  const [payMode, setPayMode] = useState("C");
  const [payAmount, setPayAmount] = useState("");
  const [remark, setRemark] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [trscNumber, setTrscNumber] = useState("");
  const [imageError, setImageError] = useState("");
  const [trscNumberError, setTrscNumberError] = useState("");
  const [payAmountError, setPayAmountError] = useState("");
  const [QRLoading, setQRLoading] = useState(false);
  const [selectedQROrder, setSelectedQROrder] = useState(null);


  const mobileRef = useRef(null);
  const imageInputRef = useRef(null);
  const payAmountRef = useRef(null);
  const transactionNoRef = useRef(null);


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (sendQRModal && mobileRef.current) {
      mobileRef.current.focus();
    }
  }, [sendQRModal]);

  useEffect(() => {
    if (sendQRModal) {
      setMobile(customer.mobile);
    }
  }, [sendQRModal]);


  useEffect(() => {
    if (selectedPaymentOrder?.header?.remainingamount) {
      setPayAmount(selectedPaymentOrder.header.remainingamount);
    }
  }, [selectedPaymentOrder]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImageFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleAddPayment = async () => {
    setImageError("");
    setPayAmountError("");
    setTrscNumberError("");

    const amount = Number(payAmount);

    if (!payAmount || isNaN(amount) || amount <= 0) {
      setPayAmountError("Enter valid payment amount");
      payAmountRef?.current?.focus();
      return;
    }

    if (payMode === "O" && !imageFile) {
      setImageError("Payment image is required for online payments");
      imageInputRef?.current?.focus();
      return;
    }

    if (payMode === "O" && !trscNumber.trim()) {
      setTrscNumberError("Transaction number is required");
      transactionNoRef?.current?.focus();
      return;
    }

    try {
      const formData = new FormData();

      formData.append("companycode", selectedPaymentOrder.header.companycode);
      formData.append("branchcode", selectedPaymentOrder.header.branchcode);
      formData.append(
        "customerordercode",
        selectedPaymentOrder.header.ordercode
      );
      formData.append("paymode", payMode === "O" ? "O" : "C");
      formData.append("amount", amount);
      formData.append("transactionno", trscNumber || "0");
      formData.append("remark", remark || "");

      if (imageFile) {
        formData.append("paymentimg", imageFile);
      }

      const response = await axios.post(
        `${BASE_MOBILE_API_URL}/add_order_payment_trsc`,
        formData,
        {
          headers: {
            Authorization: BASIC_AUTH,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        notifySuccess("Payment added successfully");

        setShowAddPaymentModal(false);
        setShowPaymentModal(false);
        setPayAmount("");
        setRemark("");
        setImageFile(null);
        await refreshOrders();
      }
    } catch (err) {
      if (err.response) {
        // Server responded with error status
        const errorMessage =
          err.response?.data && typeof err.response.data === "string"
            ? err.response.data
            : err.response?.data?.message ||
            err.response?.data?.error ||
            "Signup failed";

        notifyError(errorMessage);
      } else if (err.request) {
        // No response received
        notifyError("Server not responding. Please try again.");
      } else {
        // Other errors
        notifyError("Something went wrong.");
      }
    }
  };

  const handleSendQR = async () => {
    setQRLoading(true);
    try {
      const response = await axios.post(
        `${BASE_MOBILE_API_URL}/generate_payment_qrcode`,
        {
          upi_id: customer.branch_payment_upi_id,
          payeename: customer.companyname,
          amount: selectedQROrder.header.remainingamount,
          note: `Payment for Order ${selectedQROrder.header.ordercode}`,
          transactionref: selectedQROrder.header.ordercode,
          callfrom: "W",
          mobileno: mobile,
          ultra_msg_instance: customer.company_ultra_msg_instance,
          ultra_msg_token: customer.company_ultra_msg_token,
          companyimage: customer.company_image,
          apicallfrom: "A",
        },
        {
          headers: {
            Authorization: BASIC_AUTH,
          },
        }
      );

      if (response.status === 200) {
        setSendQRModal(false);
        notifySuccess("Payment QR sent successfully");
      }
    } catch (err) {
      if (err.response) {
        // Server responded with error status
        const errorMessage =
          err.response?.data && typeof err.response.data === "string"
            ? err.response.data
            : err.response?.data?.message ||
            err.response?.data?.error ||
            "Send QR failed";

        notifyError(errorMessage);
      } else if (err.request) {
        // No response received
        notifyError("Server not responding. Please try again.");
      } else {
        // Other errors
        notifyError("Something went wrong.");
      }
    } finally {
      setQRLoading(false);
    }
  };



  return (
    <>

      {loading ? (
        <div className="text-white">Loading purchase data...</div>
      ) : ordersData && ordersData.order_header.length === 0 ? (
        <div className="text-center text-white py-4">
          No orders found.
        </div>
      ) : (
        <>
          <div className="col-12 d-flex flex-wrap g-2">
            {ordersData.order_header?.map((header, index) => {
              const orderDetails = ordersData.order_details.filter(
                (d) => d.ordercode === header.ordercode
              );

              const paymentDetails = ordersData.order_payment_trsc.filter(
                (p) => p.customerordercode === header.ordercode
              );

              return (
                <div key={index} className="col-12 col-md-6 mb-2">
                  <div
                    className={`card order-card shadow-md h-100 m-2 pb-0 ${header.status === "C"
                      ? "order-paid-border"
                      : header.status === "O"
                        ? "order-pending-border"
                        : header.status === "X"
                          ? "order-cancelled-border"
                          : "assign-order-border"
                      }`}

                    onClick={(e) => {
                      // If clicked payment icon, do nothing
                      if (e.target.closest(".payment-icon")) return;

                      if (e.target.closest(".payment-add")) return;

                      if (e.target.closest(".long-remark-text")) return;

                      if (orderDetails) {
                        setSelectedOrder({
                          header: header,
                          details: orderDetails,
                          payments: paymentDetails,
                        });
                        setShowModal(true);
                      } else {
                        notifyError("Items are not present for this order.");
                      }
                    }}
                  >
                    {/*order card Mobile View */}
                    <div className="card-body p-1 ">
                      {/* Top Row */}
                      <div className="d-flex justify-content-between align-items-start fw-600 font-15 pb-0">
                        <div>
                          <div><b>Order #{header.ordercode}</b></div>
                          {/* <div>
                            <ExpandableTextMobile
                              text={`${header.customercode}`}
                              className="long-remark-text"
                            />
                          </div> */}

                          <div>{formatMonthDate(header.entrydate)}, {header.entrytime}</div>
                        </div>
                        {customer?.customertype === "A" && header.remainingamount > 0 && (
                          <div className="bg-white col-3 text-danger mt-2 text-sm p-1 border-theme text-center font-13 d-md-block d-none">
                            <b>Payment Pending</b>
                          </div>
                        )}
                        <div className={`text-center my-2 ${header.status === "C"
                          ? "order-paid-text"
                          : header.status === "O"
                            ? "order-pending-text"
                            : header.status === "X"
                              ? "order-cancelled-text"
                              : "assign-order-text"
                          }`}>
                          {header.status === "C"
                            ? "Completed"
                            : header.status === "O"
                              ? "In-Process"
                              : header.status === "X"
                                ? "Cancelled"
                                : "Pending"}
                        </div>


                      </div>

                      {customer?.customertype === "A" && header.remainingamount > 0 && (
                        <div className="bg-white col-12 text-danger mt-2 text-sm p-1 border-theme text-center font-13 d-md-block d-md-none">
                          <b>Payment Pending</b>
                        </div>
                      )}

                      <hr className="my-1" />

                      {/* Amount Section */}
                      <div className="col-12 d-flex text-start fw-600 align-items-center font-15">

                        {/*Mobile view - labels on left, values on right */}
                        <div className="col-3 col-md-3  text-center bg-gray ms-0">
                          <div > Items </div>
                          <div>{header.totalitem}</div>
                        </div>
                        <div className="col-3 col-md-3 text-center bg-gray">
                          <div > Amount </div>
                          <div >₹{header.totalamount} </div>
                        </div>
                        <div className="col-3 col-md-3 text-center bg-gray">
                          <div>Paid</div>

                          <div
                            className={
                              (Number(header.totalamount || 0) - Number(header.remainingamount || 0)) > 0
                                ? "text-success fw-bold"
                                : "text-dark"
                            }
                          >
                            ₹{(
                              Number(header.totalamount || 0) -
                              Number(header.remainingamount || 0)
                            ).toFixed(2)}
                          </div>
                        </div>
                        <div className="col-3 col-md-3 text-center bg-gray">
                          <div >Balance </div>
                          <div className={`${header.remainingamount > 0 ? "text-balance" : ""
                            } `}
                          >
                            ₹{header.remainingamount}
                          </div>
                        </div>



                      </div>
                      <div className="col-12 d-flex justify-content-between fw-600 align-items-center font-15 mt-1">
                        <div className="col-6 ">
                          {header.remainingamount > 0 ? (
                            <button
                              className="send-qr-btn font-11"
                              onClick={(e) => {
                                e.stopPropagation();
                                setSendQRModal(true);
                                setSelectedQROrder({
                                  header: header,
                                });
                              }}
                            >
                              Send QR
                            </button>
                          ) : (
                            <div className="paid-badge1 text-center">✓ PAID</div>
                          )}
                        </div>
                        {/* ICONS COLUMN */}
                        <div className="col-md-6 col-6 d-flex justify-content-end gap-2 text-end ">
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedPaymentOrder({
                                header: header,
                                details: orderDetails,
                                payments: paymentDetails,
                              });
                              setShowPaymentModal(true);
                            }}
                            className="mt-2"
                          >
                            <i
                              className="fa-solid fa-hand-holding-dollar text-dark fa-lg "
                              style={{ fontSize: "25px" }}
                            ></i>
                          </div>
                          {header.delivery_type === "H" && (
                            <div
                              className="mt-2 "
                              onClick={(e) => {
                                e.stopPropagation();
                                if (header.delivery_pick_up_status === "Y") {
                                  setSelectedOrderAssign({
                                    header: header,
                                    details: orderDetails,
                                    payments: paymentDetails,
                                  });

                                  setShowdeliveryModal(true);
                                } else {
                                  notifyError("Order not assigned.");
                                }
                              }}
                            >
                              <i
                                className={`fa-solid fa-truck fa-md bg-white p-1 ${header.delivery_agent_code === 0
                                  ? "text-danger"
                                  : header.delivery_delivered_status === "Y"
                                    ? "truck-green"
                                    : header.delivery_agent_code !== 0 &&
                                      header.delivery_delivered_status === "N"
                                      ? "text-theme"
                                      : " text-dark"
                                  }   `}
                                style={{
                                  borderRadius: "20px",
                                  fontSize: "25px",
                                }}
                              ></i>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Bottom Section */}
                      {header.delivery_type === "H" && (
                        <div className="col-12 d-flex justify-content-between  mt-1 font-13">
                          <div className="col-5 col-md-6 ">
                            {header.order_otp_code &&
                              header.order_otp_code !== "0" && (
                                <span className=" otp-box">
                                  Order OTP : {header.order_otp_code}
                                </span>
                              )}
                          </div>

                          {header.delivery_time_slot && (
                            <div className="col-7 col-md-6 text-end">
                              {" "}
                              <span className="timeslot-box">
                                {header.delivery_time_slot}
                              </span>{" "}
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Desktop View */}
                    {/* <div className="card-body p-1 d-none d-md-block">
                     
                      <div className="d-flex justify-content-between order-info fw-600 font-15">
                        <div>
                          <div><b>Order #{header.ordercode}</b></div>
                        
                          
                          <div>{formatMonthDate(header.entrydate)}, {header.entrytime}</div>
                        </div>
                        {customer?.customertype === "A"  && header.remainingamount > 0 && (
 <div className="bg-white col-4 col-md-5 text-center text-danger text-sm p-1 border-theme text-center">
                          <div className="mt-lg-2">Order incomplete pay remaining amount.</div>
                        </div>
                         )} 
                        <div className="text-end">
                          {header.remainingamount > 0 ? (
                            <button
                              className="send-qr-btn font-11"
                              onClick={(e) => {
                                e.stopPropagation();
                                setSendQRModal(true);
                                setSelectedQROrder({
                                  header: header,
                                });
                              }}
                            >
                              Send QR
                            </button>
                          ) : (
                            <div className="paid-badge text-center">✓ PAID</div>
                          )}
                        </div>
                      </div>



                      <hr className="my-1" />

                      
                      <div className="col-12 d-flex text-start fw-600 align-items-center font-15">



{
                        
                        <div className="col-5 col-md-5 ">
                          <div className="d-block d-md-flex justify-content-start ">
                            <div className="pe-md-2">Total Items :</div>
                            <div >{header.totalitem}</div>
                          </div>
                          <div className="d-block d-md-flex justify-content-start ">
                            <div className="pe-md-2">Total Amount :</div>
                            <div >₹{header.totalamount} </div>
                          </div>
                        </div>



                        
                        <div className="col-5 text-end col-md-6 ">
                          <div className="d-block d-md-flex justify-content-end ">
                            <div className="pe-md-2">Paid : </div>
                            <div>
                              ₹{(
                                Number(header.totalamount || 0) -
                                Number(header.remainingamount || 0)
                              ).toFixed(2)}
                            </div>
                          </div>
                          <div className="d-block d-md-flex justify-content-end ">
                            <div
                              className={`${header.remainingamount > 0 ? "text-balance" : ""
                                } pe-md-2`}
                            >
                              Balance :
                            </div>
                            <div
                              className={`${header.remainingamount > 0 ? "text-balance" : ""
                                } `}
                            >
                              ₹{header.remainingamount}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-1 col-2 d-block justify-content-center gap-2 text-end">
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedPaymentOrder({
                                header: header,
                                details: orderDetails,
                                payments: paymentDetails,
                              });
                              setShowPaymentModal(true);
                            }}
                          >
                            <i
                              className="fa-solid fa-hand-holding-dollar text-dark fa-lg"
                              style={{ fontSize: "25px" }}
                            ></i>
                          </div>
                          {header.delivery_type === "H" && (
                            <div
                              className="mt-2 "
                              onClick={(e) => {
                                e.stopPropagation();
                                if (header.delivery_pick_up_status === "Y") {
                                  setSelectedOrderAssign({
                                    header: header,
                                    details: orderDetails,
                                    payments: paymentDetails,
                                  });

                                  setShowdeliveryModal(true);
                                } else {
                                  notifyError("Order not assigned.");
                                }
                              }}
                            >
                              <i
                                className={`fa-solid fa-truck fa-md bg-white p-1 ${header.delivery_agent_code === 0
                                    ? "text-danger"
                                    : header.delivery_delivered_status === "Y"
                                      ? "truck-green"
                                      : header.delivery_agent_code !== 0 &&
                                        header.delivery_delivered_status === "N"
                                        ? "text-theme"
                                        : " text-dark"
                                  }   `}
                                style={{
                                  borderRadius: "20px",
                                  fontSize: "25px",
                                }}
                              ></i>
                            </div>
                          )}
                        </div>
                      </div>


                      
                      {header.delivery_type === "H" && (
                        <div className="col-12 d-flex justify-content-between  mt-1 font-13">
                          <div className="col-5 col-md-6 ">
                            {header.order_otp_code &&
                              header.order_otp_code !== "0" && (
                                <span className=" otp-box">
                                  Order OTP : {header.order_otp_code}
                                </span>
                              )}
                          </div>

                          {header.delivery_time_slot && (
                            <div className="col-7 col-md-6 text-end">
                              {" "}
                              <span className="timeslot-box">
                                Time Slot : {header.delivery_time_slot}
                              </span>{" "}
                            </div>
                          )}
                        </div>
                      )}
                  </div> */}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}

      {/* Floating Button */}
      <button
        className="floating-add-btn"
        onClick={() => {
          localStorage.removeItem("orderItems");
          setCreateOrderModal(true);
        }}
      >
        <i className="fa-solid fa-plus"></i>
      </button>


      <Modal
        show={showPaymentModal}
        onHide={() => setShowPaymentModal(false)}
        size={isMobile ? "lg" : "md"}
        onEntered={() => {
          setRemark("");
          setImageFile(null);
          setTrscNumber("");
        }}
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton>
            <Modal.Title className="text-theme">
              Customer Order Payment Trsc
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="p-0 d-flex flex-column payment-modal-wrapper">
            {selectedPaymentOrder &&
              (() => {
                const total = Number(
                  selectedPaymentOrder.header.totalamount || 0
                );
                const remaining = Number(
                  selectedPaymentOrder.header.remainingamount || 0
                );
                const paid = total - remaining;
                return (
                  <>
                    {/* SCROLLABLE AREA */}
                    <div className="payment-scroll-area">
                      {/* Summary Section */}

                      <div className="d-flex justify-content-between">
                        <div>
                          <b>Token No:</b>{" "}
                          {selectedPaymentOrder.header.ordercode}
                        </div>
                        {selectedPaymentOrder.header.remainingamount <= 0 ? (
                          <div className="paid-badge1 text-center ">
                            ✓ ALL PAID
                          </div>
                        ) : (
                          <>
                            <div className="d-block text-end ">
                              <button
                                className="btn btn-sm p-0"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setShowAddPaymentModal(true);
                                }}
                              >
                                <i
                                  className="fa-solid fa-plus-circle fa-2x text-success payment-add"
                                  style={{ cursor: "pointer" }}
                                ></i>
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                      <div className="d-flex justify-content-between">
                        <div>
                          <b>Total:</b> ₹{" "}
                          {selectedPaymentOrder.header.totalamount}
                        </div>
                        {selectedPaymentOrder.header.remainingamount > 0 && (
                          <div className="text-danger fw-bold">
                            <b>Balance:</b> ₹{" "}
                            {selectedPaymentOrder.header.remainingamount}
                          </div>
                        )}
                      </div>
                      <hr />

                      {selectedPaymentOrder.payments.map((p, index) => (
                        <>
                          <div
                            key={index}
                            className="card payment-card p-2 mb-2"
                          >
                            <div className="d-flex justify-content-between align-items-center">
                              {/* LEFT SIDE */}
                              <div className="d-flex flex-column align-items-start col-4">
                                <img
                                  src={
                                    p.paymode === "O"
                                      ? p.paymentimg
                                      : "/assest/cash-in-hand.png"
                                  }
                                  alt="Payment"
                                  className="rounded"
                                  style={{
                                    height: "80px",
                                    width: "70px",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>

                              {/* CENTER */}
                              <div className="text-center col-8 ">
                                <div className="d-flex justify-content-between">
                                  <div className="fw-bold mb-1">
                                    {p.paymode === "O"
                                      ? `Online (#${p.transactionno})`
                                      : p.paymode === "C"
                                        ? "Cash"
                                        : "Both"}
                                  </div>

                                  <div className="fw-bold text-success">
                                    ₹ {p.amount}
                                  </div>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <div className="small">
                                    {formatMonthDate(p.entrydate)} |{" "}
                                    {p.entrytime}
                                  </div>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <div className="small text-dark">
                                    {" "}
                                    <ExpandableTextMobile
                                      text={`${p.remark}`}
                                      className="long-text "
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ))}
                    </div>
                    <div className="payment-fixed-total">
                      <div className="d-flex justify-content-between fw-bold">
                        <span>Total Paid</span>
                        <span>₹ {paid.toFixed(2)}</span>
                      </div>
                    </div>
                  </>
                );
              })()}
          </Modal.Body>
        </div>
      </Modal>

      <Modal
        show={showAddPaymentModal}
        onHide={() => setShowAddPaymentModal(false)}
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton>
            <Modal.Title className="text-theme">Add Payment</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {selectedPaymentOrder &&
              (() => {
                const total = Number(
                  selectedPaymentOrder.header.totalamount || 0
                );
                const remaining = Number(
                  selectedPaymentOrder.header.remainingamount || 0
                );
                const paid = total - remaining;
                return (
                  <>
                    <div className="d-flex justify-content-between ">
                      <div>
                        <b>Token No:</b> {selectedPaymentOrder.header.ordercode}
                      </div>
                      <div className="text-success fw-bold  ">
                        <b>Paid:</b> ₹ {paid}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between">
                      <div>
                        <b>Total:</b> ₹{" "}
                        {selectedPaymentOrder.header.totalamount}
                      </div>

                      <div className="text-danger fw-bold ">
                        <b>Balance:</b> ₹{" "}
                        {selectedPaymentOrder.header.remainingamount}
                      </div>
                    </div>

                    <hr />

                    <div className="mb-2">
                      <label>Pay Mode</label>
                      <select
                        className="form-control"
                        value={payMode}
                        onChange={(e) => setPayMode(e.target.value)}
                      >
                        <option value="C">Cash</option>
                        <option value="O">Online</option>
                      </select>
                    </div>

                    {payMode === "O" && (
                      <>
                        <div className="mb-2 ">
                          <label className="me-2">
                            Payment Image/Screenshot
                          </label>
                          <input
                            type="file"
                            accept="image/*"
                            capture="environment"
                            id="cameraInput"
                            hidden
                            onChange={handleImageChange}
                          />

                          <button
                            className="btn btn-outline-theme"
                            onClick={() =>
                              document.getElementById("cameraInput").click()
                            }
                          >
                            📷 Take Photo
                          </button>
                          {imageError && (
                            <p className="red-error">{imageError}</p>
                          )}

                          {preview && (
                            <div className="d-flex justify-content-center">
                              <img
                                src={preview}
                                alt="Preview"
                                className="img-fluid mt-2 rounded "
                                style={{ maxHeight: "200px" }}
                              />
                            </div>
                          )}
                        </div>
                        <div className="mb-2">
                          <label>Transaction No.</label>
                          <input
                            type="text"
                            className="form-control"
                            value={trscNumber}
                            onChange={(e) => setTrscNumber(e.target.value)}
                          />
                          {trscNumberError && (
                            <p className="red-error">{trscNumberError}</p>
                          )}
                        </div>
                      </>
                    )}

                    <div className="mb-2">
                      <label>Amount</label>
                      <input
                        type="number"
                        className="form-control"
                        value={payAmount}
                        onChange={(e) => setPayAmount(e.target.value)}
                      />
                      {payAmountError && (
                        <p className="red-error">{payAmountError}</p>
                      )}
                    </div>

                    <div className="mb-2">
                      <label>Description</label>
                      <input
                        type="text"
                        className="form-control"
                        value={remark}
                        onChange={(e) => setRemark(e.target.value)}
                      />
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                      <button
                        className="btn btn-success col-md-4 col-8"
                        onClick={handleAddPayment}
                      >
                        Submit Payment
                      </button>
                    </div>
                  </>
                );
              })()}
          </Modal.Body>
        </div>
      </Modal>

      <Modal
        show={showdeliveryModal}
        onHide={() => setShowdeliveryModal(false)}
      >
        <div className="bg-Modal-black">
          <Modal.Header>
            <Modal.Title className="text-theme">
              <i className="fa-solid fa-truck fa-lg"></i> Order Delivery Info{" "}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {selectedOrderAssign &&
              (() => {
                return (
                  <>
                    <div>
                      <b className="text-theme">Order Assign Info :</b>
                      <div className="d-block mt-2 mb-1">
                        <div className="d-flex">
                          <h6 className="me-2">Delivery Person : </h6>{" "}
                          {selectedOrderAssign.header.delivery_agent_name}
                        </div>
                        <div className="d-flex">
                          <h6 className="me-2">Delivery Mobile : </h6>{" "}
                          {selectedOrderAssign.header.delivery_mobile_no}
                        </div>

                        <div className="d-flex">
                          <h6 className="me-2">Date / Time : </h6>{" "}
                          {formatMonthDate(
                            selectedOrderAssign.header.delivery_pick_up_date
                          )}{" "}
                          / {selectedOrderAssign.header.delivery_pick_up_time}
                        </div>
                      </div>
                    </div>
                    <hr className="m-0" />

                    <div className="mt-2">
                      <b className="text-theme">Order Pickup Info :</b>
                      <div className="d-block mt-2 mb-1">
                        <div className="d-flex">
                          <h6 className="me-2">Date / Time : </h6>{" "}
                          {formatMonthDate(
                            selectedOrderAssign.header.start_delivery_date
                          )}{" "}
                          / {selectedOrderAssign.header.start_delivery_time}
                        </div>
                      </div>
                    </div>
                    <hr className="m-0" />
                    {selectedOrderAssign.header.delivery_delivered_status ===
                      "Y" && (
                        <div className="mt-2">
                          <b className="text-theme">Order Delivered Info :</b>
                          <div className="d-block mt-2 mb-1">
                            <div className="d-flex">
                              <h6 className="me-2 ">Date / Time : </h6>{" "}
                              {formatMonthDate(
                                selectedOrderAssign.header.delivered_date
                              )}{" "}
                              / {selectedOrderAssign.header.delivered_time}
                            </div>
                            <div className="d-flex">
                              <h6 className="me-2">Remark : </h6>{" "}
                              <ExpandableTextMobile
                                text={`${selectedOrderAssign.header.delivery_remark}`}
                                className="long-text"
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    <hr className="m-0" />

                    <div className="d-flex justify-content-center mt-3">
                      <button
                        className="btn btn-success col-4"
                        onClick={() => {
                          setShowdeliveryModal(false);
                          setSelectedOrderAssign(null);
                        }}
                      >
                        Ok
                      </button>
                    </div>
                  </>
                );
              })()}
          </Modal.Body>
        </div>
      </Modal>

      <Modal
        show={sendQRModal}
        onHide={() => setSendQRModal(false)}
        backdrop="static"
        keyboard={false}
        onEntered={() => {
          setMobileError("");
          if (mobileRef.current) {
            mobileRef.current.focus();
          }
        }}
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton>
            <Modal.Title className="text-theme">
              Send Payment QR Code
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <label className="form-label small text-white fw-semibold">
                <i className="fa-solid fa-phone text-warning"></i> WhatsApp No.{" "}
                <span className="red-error">*</span>
              </label>
              <input
                type="tel"
                className="form-control"
                placeholder="Enter whatsapp number"
                ref={mobileRef}
                value={mobile}
                onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
                maxLength={10}
              />
              {mobileError && <p className="red-error">{mobileError}</p>}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <ButtonSpinner
              variant="success"
              className="btn btn-success"
              loading={QRLoading}
              onClick={() => {
                handleSendQR();
              }}
            >
              <b>{QRLoading ? "Sending QR..." : "Send QR"}</b>
            </ButtonSpinner>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};

export default OrderList;
